'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CommonTabProps = exports.GetSignatureUrl = exports.OnSignatureData = exports.ActionBar = exports.Tab = exports.ScreenSize = exports.DeviceOrientation = exports.Type = exports.SignatureType = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PropTypes = _react2['default'].PropTypes;
var SignatureType = exports.SignatureType = PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    guid: PropTypes.string.isRequired
});

var Type = exports.Type = PropTypes.oneOf([_constants2['default'].TYPE_SIGNATURE, _constants2['default'].TYPE_INITIALS]);

var DeviceOrientation = exports.DeviceOrientation = PropTypes.oneOf([_constants2['default'].ORIENTATION_PORTRAIT, _constants2['default'].ORIENTATION_LANDSCAPE]);

var ScreenSize = exports.ScreenSize = PropTypes.oneOf([_constants2['default'].SCREEN_SMALL, _constants2['default'].SCREEN_MEDIUM, _constants2['default'].SCREEN_LARGE]);

var Tab = exports.Tab = PropTypes.oneOf(_constants2['default'].TABS);

var ActionBar = exports.ActionBar = {

    // Text to be displayed on the CTA (only when canInsertEverywhere=false)
    buttonText: PropTypes.string,
    canInsertEverywhere: PropTypes.bool,
    continueInsteadOfInsert: PropTypes.bool,
    disableButtons: PropTypes.bool,
    intl: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onContinue: PropTypes.func,
    onInsert: PropTypes.func,
    type: Type,

    // If provided, this indicates that the action bar should be absolutely
    // positioned starting from this point.  If it's not provided, then it
    // will be absolutely positioned at the bottom of the screen
    topOffset: _react2['default'].PropTypes.number
};

var OnSignatureData = exports.OnSignatureData = PropTypes.func;

var GetSignatureUrl = exports.GetSignatureUrl = PropTypes.func.isRequired;

var CommonTabProps = exports.CommonTabProps = {
    actionBarProps: PropTypes.shape(ActionBar),
    buttonText: PropTypes.string,
    canInsertEverywhere: PropTypes.bool,

    // Provided to the Tab components so that they can report their
    // content to this component.  The tabs should apply this as a ref
    // callback on the div that wraps the content, e.g.
    // <div ref={this.props.captureTabContentRef}>
    captureTabContentRef: PropTypes.func,
    deviceOrientation: DeviceOrientation,
    emailGuid: PropTypes.string,
    emailUploadAddress: PropTypes.string,
    intl: PropTypes.object,
    isMobile: PropTypes.bool,
    isSelected: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    screenSize: ScreenSize,
    topOffset: PropTypes.number,
    type: Type
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/prop-types.js
 ** module id = 794
 ** module chunks = 0 1
 **/